var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.dataFetched)?_c('div',{staticClass:"gin-page-wrapper"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("back")]),_c('gin-single',{attrs:{"ginData":_vm.currentGin}})],1):_c('loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }